import { render, staticRenderFns } from "./Compose.vue?vue&type=template&id=cd733b26"
import script from "./Compose.vue?vue&type=script&lang=js"
export * from "./Compose.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports